
import PreviewBulkDataViewModel from '@/entities/ImportFile/PreviewBulkDataViewModel';
import SubModuleEnum from '@/enums/SubModuleEnum';
import { Root, Store } from '@/main';
import { ProgramSignalRModel } from '@/signalRRequest/Program/ProgramSignalRModel';
import { SignalRModelRequest } from '@/signalRRequest/SignalRModelRequest';
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import ValidationSummary from '../ValidationSummary.vue';
@Component({
  components: {
    ValidationSummary,
  },
})
class PreviewBulkData extends Vue {
  @Prop() previewImportedData!: PreviewBulkDataViewModel;
  private localPreviewData: PreviewBulkDataViewModel = PreviewBulkDataViewModel.createEmpty();
  private isValidationSummaryVisible = false;
  private errorRowIndexes: number[] = [];
  private localImportProgramsBulkOperationModel: SignalRModelRequest = new SignalRModelRequest();
  private localbulkEditOperations: any= null;
  private signalR: ProgramSignalRModel = new ProgramSignalRModel(
    Root,
    Store,
    this.$t,
  );


  private mounted() {
    if (this.previewImportedData !== null && this.previewImportedData !== undefined ) {
      this.localPreviewData = this.previewImportedData;
      this.localImportProgramsBulkOperationModel = Object.assign({}, this.signalR.arrSignalRModelRequests.find((e)=> e.SubModule === this.localPreviewData.SubModuleType));
      Root.emit('program-import-inprogress', true);
    }
  }

  private HideImportPreview() {
    this.$emit('hide-import-preview',false);
  }
  private Import() {
    this.errorRowIndexes = this.localPreviewData.ValidationErrors.index;
    if(this.errorRowIndexes.length === 0) {
      this.localImportProgramsBulkOperationModel.JSONData = JSON.stringify(this.localPreviewData.JsonData);
      this.localImportProgramsBulkOperationModel.Heading = this.$t(
        this.localImportProgramsBulkOperationModel.Heading,
      ).toString();
      setTimeout(() => {
        Root.emit('show-notification-popup', true);
        Root.emit('show-notification-loading', true);
      }, 100);
      this.localImportProgramsBulkOperationModel.Description = this.$t(
        this.localImportProgramsBulkOperationModel.SubmitMessage,
        {
          selectedCount: 0,
          user: this.signalR.GetUserName(
            this.localImportProgramsBulkOperationModel,
            this.$t('UserName.You').toString(),
          ),
        },
      ).toString();
      Root.emit('empty-active-sub-component');
      this.localImportProgramsBulkOperationModel.SelectedIds = [];
      this.localImportProgramsBulkOperationModel.SubModule = SubModuleEnum.ImportPrograms;
      this.signalR.PerformProgramBatchOperation(
        this.localImportProgramsBulkOperationModel,
      );
    } else {
      this.isValidationSummaryVisible = true;
    }
  }
  private CloseValidationSummary(val: boolean) {
    this.isValidationSummaryVisible = val;
  }
  private ErrorInRow(index: number) {
    return this.errorRowIndexes.includes(index) ? true : false;
  }
  private DisplayPropertyInPreview(item: any) {
    if(typeof(item) === 'object' && item.ShowInPreview === false) {
      return true;
    } else {
      return false;
    }
  }
  private ShowValue(item: any) {
    if(typeof(item) === 'object') {
      return item.PropName;
    } else {
      return item;
    }
  }
  private GetTableData(val: string) {
    return val !== null && val !== undefined && val !== '' ? val : '-';
  }
  private beforeUnmount() {
    Root.emit('program-import-inprogress', false);
  }
}
export default toNative(PreviewBulkData);
